import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Account,
  MarketEdit,
  TelegramUser,
  UserResponse,
  UserSettings,
  UserState,
} from "../../_app/types";

const initialState: UserState = {
  profile: {
    profileId: "",
    username: "",
    accounts: [],
    settings: [],
    email: "",
    subscription: null,
  },
  telegramUser: null,
  activeAccount: {
    id: "",
    name: "",
    market: "",
    marginType: "",
    leverage: 0,
    linkDateTime: null,
  },
  newNotification: false,
  canStartBot: true,
  token: null,
};

const UPDATE_ACTIVE_ACCOUNT_NAME = "UPDATE_ACTIVE_ACCOUNT_NAME";

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserResponse>) => {
      state.profile = action.payload;
    },
    setAccounts: (state, action: PayloadAction<Account[]>) => {
      state.profile.accounts = action.payload;
    },
    setTelegramUser: (state, action: PayloadAction<TelegramUser>) => {
      state.telegramUser = action.payload;
    },
    switchAccount: (state, action: PayloadAction<Account>) => {
      state.activeAccount = action.payload;
    },
    updateTelegramNotificationToggle: (state, action: PayloadAction<string>) => {
      state.profile.settings = state.profile.settings.map((setting) => {
        if (setting.name === "TELEGRAM_NOTIFICATION_ENABLED") {
          console.log(action.payload);
          return { ...setting, value: action.payload };
        }
        return setting;
      });
    },
    updateAccount: (
      state,
      action: PayloadAction<{ accountId: string; accountData: MarketEdit }>
    ) => {
      state.profile.accounts = state.profile.accounts.map((account) => {
        if (account.id === action.payload.accountId) {
          return { ...account, ...action.payload.accountData };
        }

        return account;
      });

      if (action.payload.accountId === state.activeAccount.id) {
        state.activeAccount = { ...state.activeAccount, ...action.payload.accountData };
      }
    },
    updateToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    lockStartBot: (state) => {
      state.canStartBot = false;
    },
    unlockStartBot: (state) => {
      state.canStartBot = true;
    },
    readNotification: (state) => {
      state.newNotification = false;
    },
    newNotification: (state) => {
      state.newNotification = true;
    },
    logoutUser: (state) => {
      state.profile = {
        profileId: "",
        username: "",
        accounts: [],
        settings: [],
        email: "",
        subscription: null,
      };
      state.activeAccount = {
        id: "",
        name: "",
        market: "",
        marginType: "",
        leverage: 0,
        linkDateTime: null,
      };
    },
    updateActiveAccountName: (state, action: PayloadAction<string>) => {
      state.activeAccount.name = action.payload;
    },
  },
});

export const {
  setUser,
  switchAccount,
  logoutUser,
  setAccounts,
  setTelegramUser,
  newNotification,
  readNotification,
  lockStartBot,
  unlockStartBot,
  updateToken,
  updateTelegramNotificationToggle,
  updateActiveAccountName,
  updateAccount,
} = userSlice.actions;

export default userSlice.reducer;
